import axios from "../../../../../../api/axiosInstance";
import {
  GenerateThumbnailPreviewRequest,
  GenerateThumbnailPreviewResponse,
} from "./types";

export const generateThumbnailPreview = async (
  payload: GenerateThumbnailPreviewRequest,
): Promise<GenerateThumbnailPreviewResponse> => {
  const response = await axios.post<GenerateThumbnailPreviewResponse>(
    "/api/private/resource/thumbnail/generate-preview",
    payload,
  );
  return response.data;
};
